import type { ReactNode } from "react";

import { Card } from "@luce/ui";

import { useClientPackage } from "../gqlhooks/use-client-package";
import { PackageDetailFallback } from "./components/package-detail-fallback";
import { PackageDetailSkeleton } from "./components/package-detail-skeleton";
import { PackageDetailContext } from "./package-detail-context";

interface PackageDetailProps {
  packageId: string;
  children: ReactNode;
}

export function PackageDetailScreen({ packageId, children }: PackageDetailProps) {
  const { packageDetail, isActive, isAdHoc, loading, error, refetch } = useClientPackage(packageId);

  if (loading && !packageDetail) return <PackageDetailSkeleton />;
  if (!packageDetail && error) {
    return (
      <PackageDetailFallback
        message="Something went wrong loading your package."
        onRetry={() => refetch()}
      />
    );
  }
  if (!packageDetail) return <PackageDetailFallback message="This package isn't available." />;

  return (
    <PackageDetailContext.Provider value={{ packageDetail, isActive, isAdHoc }}>
      <Card gap="none" className="p-spacing-0 border-0 md:border">
        {children}
      </Card>
    </PackageDetailContext.Provider>
  );
}
